export default __webpack_public_path__ + "static/media/plugin-alpha-step3.2d3631e1.jpg";